(function() { window.GUID_72adae74_3253_46bb_937a_41b88b89ba57 = { getGuid: function() { return "72adae74-3253-46bb-937a-41b88b89ba57"; } }; })();
/**
 * Controls of the score sheet finder.
 *
 * Every control of the toolbar, of the chips row and of the drawers is plain HTML: the
 * helpers below are the only thing the finder needs in order to read and write them.
 * They know about the markup of the finder, never about its filters, so the finder
 * keeps its business rules in the store and only calls into this file to render.
 */
class ScoreSheetFinderControls {
    constructor() { }
    /** Reads the value of a select, an empty string standing for "not configured". */
    static getSelectValue($select) {
        if (!($select === null || $select === void 0 ? void 0 : $select.length)) {
            return "";
        }
        const value = $select.val();
        return value == null ? "" : value.toString();
    }
    /**
     * Writes the value of a select. Setting the value of a select from script never
     * raises its change event, so this never loops back into the filters.
     */
    static setSelectValue($select, value) {
        if (!($select === null || $select === void 0 ? void 0 : $select.length)) {
            return;
        }
        $select.val(value == null ? "" : value.toString());
    }
    /**
     * Marks a control as configured or not. The accent given to a configured filter is
     * a style of the finder, applied through a class of its own.
     */
    static setControlActiveState($control, isActive) {
        if (!($control === null || $control === void 0 ? void 0 : $control.length)) {
            return;
        }
        $control.addClass("ssf-filter-control");
        $control.toggleClass("ssf-filter-control--active", isActive === true);
    }
    /** Reads the state of a switch. Switches are checkboxes styled as a track. */
    static isSwitchChecked($switch) {
        if (!($switch === null || $switch === void 0 ? void 0 : $switch.length)) {
            return false;
        }
        return $switch.prop("checked") === true;
    }
    static setSwitchChecked($switch, checked) {
        if (!($switch === null || $switch === void 0 ? void 0 : $switch.length)) {
            return;
        }
        $switch.prop("checked", checked === true);
    }
    static isChipSelected($chip) {
        if (!($chip === null || $chip === void 0 ? void 0 : $chip.length)) {
            return false;
        }
        return $chip.hasClass("ssf-chip--selected");
    }
    /**
     * Selects a chip. A chip that is not always visible is only shown while it is
     * selected, which is what makes the chips row the list of the active filters.
     */
    static setChipSelected($chip, selected) {
        if (!($chip === null || $chip === void 0 ? void 0 : $chip.length)) {
            return;
        }
        $chip.toggleClass("ssf-chip--selected", selected === true);
        $chip
            .closest(".scoreSheetFinderChipContainer")
            .toggleClass("selected", selected === true);
    }
    static setChipLabel($chip, label) {
        if (!($chip === null || $chip === void 0 ? void 0 : $chip.length)) {
            return;
        }
        $chip.find(".ssf-chip__label").text(label !== null && label !== void 0 ? label : "");
    }
    static isDrawerOpen($drawer) {
        if (!($drawer === null || $drawer === void 0 ? void 0 : $drawer.length)) {
            return false;
        }
        return $drawer.hasClass("ssf-drawer--open");
    }
    /** Opens or closes a drawer. Omitting the state toggles it. */
    static toggleDrawer($drawer, state) {
        if (!($drawer === null || $drawer === void 0 ? void 0 : $drawer.length)) {
            return;
        }
        const open = state == null ? !ScoreSheetFinderControls.isDrawerOpen($drawer) : state;
        $drawer.toggleClass("ssf-drawer--open", open);
        $drawer.attr("aria-hidden", open ? "false" : "true");
    }
    /**
     * Shows a short lived message at the bottom of the screen. It replaces the
     * notification widget, which was the last thing the thumbnail helper needed.
     */
    static showToast(message, type) {
        try {
            const $toast = $(`<div class="ssf-toast ssf-toast--${type !== null && type !== void 0 ? type : "success"}"></div>`);
            $toast.text(message);
            $("body").append($toast);
            setTimeout(function () {
                $toast.addClass("ssf-toast--leaving");
                setTimeout(function () {
                    $toast.remove();
                }, 250);
            }, 3000);
        }
        catch (error) {
            console.error("Error while showing toast", error);
        }
    }
}
/**
 * Search by id control: a text input that turns the ids it is given into tokens.
 *
 * It is fed once with the ids of the initial result set and never refreshed
 * afterwards, exactly like the widget it replaces.
 */
class ScoreSheetFinderTokenInput {
    constructor($root, onChange) {
        this.source = [];
        this.selected = [];
        this.$root = $root;
        this.$values = $root.find(".ssf-tokens__values");
        this.$input = $root.find(".ssf-tokens__input");
        this.$suggestions = $root.find(".ssf-tokens__suggestions");
        this.onChange = onChange !== null && onChange !== void 0 ? onChange : function () { };
        this.bindEvents();
        this.render();
    }
    /** Ids the user can pick from. */
    setSource(source) {
        const ids = [];
        (Array.isArray(source) ? source : []).forEach(function (item) {
            const id = Number(item);
            if (!isNaN(id) && ids.indexOf(id) === -1) {
                ids.push(id);
            }
        });
        this.source = ids;
    }
    value() {
        return this.selected.slice(0);
    }
    setValue(values) {
        const ids = [];
        (Array.isArray(values) ? values : []).forEach(function (item) {
            const id = Number(item);
            if (!isNaN(id) && ids.indexOf(id) === -1) {
                ids.push(id);
            }
        });
        this.selected = ids;
        this.render();
    }
    /** Clears the selection without notifying, used when the finder resets itself. */
    clear() {
        this.selected = [];
        this.$input.val("");
        this.hideSuggestions();
        this.render();
    }
    bindEvents() {
        const me = this;
        this.$input.on("input", function () {
            me.showSuggestions();
        });
        this.$input.on("focus", function () {
            me.showSuggestions();
        });
        this.$input.on("keydown", function (e) {
            var _a;
            if (e.key === "Enter") {
                e.preventDefault();
                me.addFromInput();
                return;
            }
            if (e.key === "Escape") {
                me.hideSuggestions();
                return;
            }
            if (e.key === "Backspace" &&
                ((_a = me.$input.val()) !== null && _a !== void 0 ? _a : "").toString().length === 0) {
                me.removeLast();
            }
        });
        this.$root.on("click", ".ssf-token__remove", function (e) {
            e.stopPropagation();
            const id = Number($(e.currentTarget).closest(".ssf-token").data("id"));
            me.remove(id);
        });
        this.$root.on("mousedown", ".ssf-tokens__suggestion", function (e) {
            // Handled on mousedown so that the input losing the focus does not close
            // the list before the click lands on the suggestion.
            e.preventDefault();
            me.add(Number($(e.currentTarget).data("id")));
            me.$input.val("");
            me.hideSuggestions();
        });
        this.$root.on("click", function (e) {
            if (!$(e.target).closest(".ssf-token").length) {
                me.$input.trigger("focus");
            }
        });
        this.$input.on("blur", function () {
            me.hideSuggestions();
        });
    }
    addFromInput() {
        var _a;
        const text = ((_a = this.$input.val()) !== null && _a !== void 0 ? _a : "").toString().trim();
        if (!text.length) {
            return;
        }
        const id = Number(text);
        if (isNaN(id) || this.source.indexOf(id) === -1) {
            return;
        }
        this.add(id);
        this.$input.val("");
        this.hideSuggestions();
    }
    add(id) {
        if (isNaN(id) || this.selected.indexOf(id) > -1) {
            return;
        }
        this.selected.push(id);
        this.render();
        this.onChange(this.value());
    }
    remove(id) {
        const index = this.selected.indexOf(id);
        if (index === -1) {
            return;
        }
        this.selected.splice(index, 1);
        this.render();
        this.onChange(this.value());
    }
    removeLast() {
        if (!this.selected.length) {
            return;
        }
        this.remove(this.selected[this.selected.length - 1]);
    }
    showSuggestions() {
        var _a;
        const text = ((_a = this.$input.val()) !== null && _a !== void 0 ? _a : "").toString().trim();
        const me = this;
        const matches = this.source
            .filter(function (id) {
            if (me.selected.indexOf(id) > -1) {
                return false;
            }
            return text.length === 0 || id.toString().indexOf(text) > -1;
        })
            .slice(0, ScoreSheetFinderTokenInput.maxSuggestions);
        this.$suggestions.empty();
        if (!matches.length) {
            this.hideSuggestions();
            return;
        }
        matches.forEach(function (id) {
            const $suggestion = $('<li class="ssf-tokens__suggestion" role="option"></li>');
            $suggestion.attr("data-id", id);
            $suggestion.text(id.toString());
            me.$suggestions.append($suggestion);
        });
        this.$root.addClass("ssf-tokens--open");
    }
    hideSuggestions() {
        this.$root.removeClass("ssf-tokens--open");
    }
    render() {
        var _a;
        const me = this;
        this.$values.empty();
        this.selected.forEach(function (id) {
            const $token = $('<span class="ssf-token"></span>');
            $token.attr("data-id", id);
            $token.append($('<span class="ssf-token__label"></span>').text(id.toString()));
            $token.append($('<button type="button" class="ssf-token__remove" aria-label="' +
                CS.CSRess({
                    english: "Remove",
                    french: "Retirer",
                    spanish: "Quitar",
                }) +
                '">&times;</button>'));
            me.$values.append($token);
        });
        // The placeholder is only useful while nothing has been picked yet.
        this.$input.attr("placeholder", this.selected.length ? "" : (_a = this.$root.data("placeholder")) !== null && _a !== void 0 ? _a : "");
    }
}
/** Number of suggestions shown at once, so that a large result set stays usable. */
ScoreSheetFinderTokenInput.maxSuggestions = 50;

//# sourceMappingURL=ScoreSheetFinderControls.js.map
